import type { ReactNode } from "react";
import { cx } from "../../lib/cx";

interface AlertProps {
  tone?: "default" | "danger";
  title?: string;
  children: ReactNode;
  action?: ReactNode;
}

export function Alert({ tone = "default", title, children, action }: AlertProps) {
  return (
    <div className={cx("alert", tone === "danger" && "alert--danger")} role={tone === "danger" ? "alert" : undefined}>
      {title && <div className="alert__title">{title}</div>}
      <div>{children}</div>
      {action}
    </div>
  );
}
